/* Still night · full-screen image viewer
 * Click / tap toggles between fit-to-screen and natural (full) size, mimicking
 * a browser's native image view. When zooming in we scroll so the clicked
 * point stays roughly under the pointer. Keyboard: Enter / Space toggles.
 */
(function () {
  function initViewer(viewer) {
    var img = viewer.querySelector('[data-sn-qr-img]');
    if (!img) return;

    function zoomInAt(clientX, clientY) {
      var rect = img.getBoundingClientRect();
      // Where the point sits within the fit-mode image (0..1).
      var relX = rect.width ? (clientX - rect.left) / rect.width : 0.5;
      var relY = rect.height ? (clientY - rect.top) / rect.height : 0.5;
      relX = Math.min(Math.max(relX, 0), 1);
      relY = Math.min(Math.max(relY, 0), 1);

      viewer.classList.add('is-zoomed');

      // After the browser lays out the natural-size image, centre on the point.
      requestAnimationFrame(function () {
        viewer.scrollLeft = relX * img.offsetWidth - viewer.clientWidth / 2;
        viewer.scrollTop = relY * img.offsetHeight - viewer.clientHeight / 2;
      });
    }

    function zoomOut() {
      viewer.classList.remove('is-zoomed');
      viewer.scrollTop = 0;
      viewer.scrollLeft = 0;
    }

    function toggle(clientX, clientY) {
      if (viewer.classList.contains('is-zoomed')) {
        zoomOut();
      } else {
        zoomInAt(clientX, clientY);
      }
    }

    img.addEventListener('click', function (e) {
      toggle(e.clientX, e.clientY);
    });

    img.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        var rect = img.getBoundingClientRect();
        toggle(rect.left + rect.width / 2, rect.top + rect.height / 2);
      }
    });
  }

  function init() {
    var viewers = document.querySelectorAll('[data-sn-qr-viewer]');
    for (var i = 0; i < viewers.length; i++) initViewer(viewers[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
